import {
  getFirstLinkedItemOrDefault,
  type PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import { getCtaHrefValue, getFirstMappedLinkedItemOrDefault } from './utils';

export const pre_registration_manager_panel = (
  entry: PLAYER_PORTALS_MODELS.PreRegistrationManagerPanel,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry;

  return {
    title: elements.title?.value,
    formComponent: getFirstMappedLinkedItemOrDefault(elements.form_component),
    resource: getCtaHrefValue(getFirstLinkedItemOrDefault(elements?.resource)),
  };
};

export default pre_registration_manager_panel;
